import { useMemo, useState } from 'react';
import { Flex, SystemProps, Box } from '@storyofams/react-ui';
import { Image as StoryblokImage } from '@storyofams/storyblok-toolkit';

import { isEmpty } from 'lodash';
import { Heading, Text, Button } from '~components';
import { Grid } from '~components/meals/ProductsGrid';
import DetailModal from './DetailModal';
import { ThemeBoxProduct } from './ThemeBoxProduct'
import { SectionWrapper } from '~components/common/SectionWrapper';

interface MealsGridProps extends SystemProps {
  title: string;
  meals: Record<string, any>[];
  moreInfoButtonText: string;
}

export const MealsGrid = ({ title, meals, backgroundColor, moreInfoButtonText, ...props }: MealsGridProps) => {
  const [content, setContent] = useState(null);
  return (
    <>
      <SectionWrapper backgroundColor={backgroundColor}>
        <Box
          mx={[3, 10]}
          my={[6]}
        >
          <Flex
            flexDirection="column"
            width="100%" {...props}
          >
            <Heading
              as="h1"
              variant="sh1"
              fontSize={['30px', '30px']}
              mb={[2]}
              color={'#21857F'}
            >
              {title}
            </Heading>

            <Grid
              gridTemplateColumns={
                !!meals?.length && meals.length >= 4
                  ? ['1fr', 'repeat(2, 1fr)', 'repeat(4, 1fr)']
                  : ['1fr', 'repeat(2, 1fr)', 'repeat(3, 1fr)']
                }
            >
              {meals?.map((meal) => {
                return(
                  <ThemeBoxProduct
                    key={`ThemeBoxProduct-${meal?.uuid}`}
                    title={meal?.content?.title}
                    description={meal?.content?.shortDescription}
                    image={meal?.content?.image}
                    textBlockBackgroundColor={meal?.content?.text_block_background_color?.color}
                    backgroundColor={meal?.content?.background_color?.color}
                    fontColor={meal?.content?.font_color?.color}
                    textureType={meal?.content?.texture_type}
                    smallText={!!meals?.length && meals.length >= 4}
                    MoreInfoButton={() => (
                      <>
                        {!!meal?.content?.details ? (
                          <Button
                            key={`${meal?.content?._uid}-${meal?.content?.title}-${Math.floor(Math.random() * 100)}`}
                            variant="button_type_2"
                            alignItems="center"
                            width="100%"
                            onClick={() =>
                              meal?.content?.details ? setContent(meal?.content) : null
                            }
                            cursor={meal?.content?.details ? 'pointer' : 'default'}
                          >
                            {moreInfoButtonText}
                          </Button>
                        ) : null}
                      </>

                    )}
                  />
                )
                  {/* <StoryblokImage
                    width="100%"
                    src={meal?.content?.image.filename}
                    alt={meal?.content?.image.alt}
                  />

                  <Heading variant="sh4" as="h2" textAlign="center" mt={3}>
                    {meal?.content?.title}
                  </Heading>

                  <Text textAlign="center" mt={[1, 2]}>
                    {meal?.content?.shortDescription}
                  </Text> */}
               
              })}
            </Grid>
          </Flex>
        </Box>
      </SectionWrapper>
      <DetailModal
        open={!isEmpty(content)}
        toggleOpen={() => setContent(null)}
        content={content?.details}
        title={content?.title}
      />
    </>
  );
};
